(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-picket-planner"] && !Shopify.designMode) return;
  try {
    
function mtPicketPanel(width, picket, maximumGap, ends) {
  if (![width, picket, maximumGap].every(Number.isFinite) || width <= 0 || width > 10000 || picket <= 0 || maximumGap < 1 || maximumGap > 200 || !['equal','half'].includes(ends)) throw new Error('invalid');
  const offset = ends === 'equal' ? 1 : 0;
  const count = Math.max(1, Math.ceil((width - offset * maximumGap) / (picket + maximumGap) - 1e-10));
  const remaining = width - count * picket;
  if (remaining < -1e-7) throw new Error('impossible');
  const gap = Math.max(0, remaining) / (count + offset);
  if (gap > maximumGap + 1e-7) throw new Error('impossible');
  return {count, gap, endGap: ends === 'half' ? gap / 2 : gap};
}
function mtPicketOrder(rows, picket, gap, ends, spares) {
  if (!Array.isArray(rows) || rows.length < 1 || rows.length > 20 || !Number.isInteger(spares) || spares < 0 || spares > 1000) throw new Error('invalid');
  const panels = rows.map(row => {
    if (!Number.isInteger(row.quantity) || row.quantity < 1 || row.quantity > 100) throw new Error('invalid');
    return {...mtPicketPanel(row.width, picket, gap, ends), width:row.width, quantity:row.quantity};
  });
  const needed = panels.reduce((sum,panel) => sum + panel.count * panel.quantity, 0);
  const extra = Math.max(0, 10 - needed - spares);
  return {panels, needed, extra, total:needed + spares + extra};
}
class MtPicketPlanner extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.q = selector => this.querySelector(selector);
    this.catalogue = JSON.parse(this.q('[data-catalogue]').textContent);
    this.words = JSON.parse(this.q('[data-words]').textContent);
    this.money = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {style:'currency',currency:this.dataset.currency || 'AUD'});
    this.q('[data-profile]').addEventListener('change', () => this.chooseProfile());
    this.addEventListener('input', event => { if (!event.target.matches('[data-profile]')) this.update(); });
    this.addEventListener('change', event => { if (!event.target.matches('[data-profile]')) this.update(); });
    this.q('[data-add]').addEventListener('click', () => {
      if (this.querySelectorAll('.mt-planner__row').length >= 20) return;
      const row = this.q('.mt-planner__row').cloneNode(true);
      row.querySelector('[data-panel-width]').value = '';
      row.querySelector('[data-panel-count]').value = '1';
      this.q('[data-rows]').append(row);
      this.syncRows(); this.update(); row.querySelector('input').focus();
    });
    this.q('[data-rows]').addEventListener('click', event => {
      const button = event.target.closest('[data-remove]');
      if (!button || this.querySelectorAll('.mt-planner__row').length <= 1) return;
      button.closest('.mt-planner__row').remove(); this.syncRows(); this.update(); this.q('[data-add]').focus();
    });
    this.chooseProfile();
  }
  syncRows() {
    const rows = [...this.querySelectorAll('.mt-planner__row')];
    rows.forEach(row => {row.querySelector('[data-remove]').disabled = rows.length === 1;});
    this.q('[data-add]').disabled = rows.length >= 20;
  }
  chooseProfile() {
    this.product = this.catalogue.find(product => String(product.id) === this.q('[data-profile]').value);
    if (!this.product) {this.fail('unavailable');return;}
    for (const field of ['width','length']) {
      const input = this.q(`[data-${field}]`), previous = input.value;
      const values = [...new Set(this.product.variants.map(variant => variant[field]))];
      input.replaceChildren(...values.map(value => new Option(value,value)));
      if (values.includes(previous)) input.value = previous;
    }
    const image = this.q('.mt-planner__image img');
    if (image) {image.src = this.product.image;image.removeAttribute('srcset');image.alt = this.product.title;}
    this.update();
  }
  fail(code) {
    this.q('[data-error]').hidden = false;
    this.q('[data-error]').textContent = this.words[code] || this.words.invalid;
    this.q('[data-result]').hidden = true;
    this.q('[data-review]').removeAttribute('href');
    this.q('[data-review]').setAttribute('aria-disabled','true');
  }
  update() {
    const variant = this.product?.variants.find(v => v.width === this.q('[data-width]').value && v.length === this.q('[data-length]').value);
    this.q('[data-unit]').textContent = variant ? `${this.money.format(variant.price / 100)} ${this.words.each}` : this.words.unavailable;
    const ends = this.q('[data-ends]').value;
    this.q('[data-end-note]').textContent = this.words[`${ends}_note`];
    this.q('.mt-planner__diagram').dataset.mode = ends;
    if (!variant || !variant.available) {this.fail('unavailable');return;}
    try {
      const inputs = [...this.querySelectorAll('input[type=number]')];
      if (inputs.some(input => input.value === '' || !input.validity.valid)) throw new Error('invalid');
      const rows = [...this.querySelectorAll('.mt-planner__row')].map(row => ({width:Number(row.querySelector('[data-panel-width]').value),quantity:Number(row.querySelector('[data-panel-count]').value)}));
      const picket = Number(variant.width.replace(/\s*mm\s*$/i,''));
      const spares = Number(this.q('[data-spares]').value);
      const result = mtPicketOrder(rows,picket,Number(this.q('[data-gap]').value),ends,spares);
      this.q('[data-error]').hidden = true;this.q('[data-result]').hidden = false;
      this.q('[data-total]').textContent = result.total;
      this.q('[data-needed]').textContent = result.needed;
      this.q('[data-spare-total]').textContent = spares;
      this.q('[data-minimum]').textContent = result.extra;
      this.q('[data-minimum-row]').hidden = result.extra === 0;
      this.q('[data-price]').textContent = this.money.format(result.total * variant.price / 100);
      this.q('[data-breakdown]').replaceChildren(...result.panels.map(panel => {
        const row = document.createElement('p'), heading = document.createElement('strong');
        heading.textContent = `${panel.quantity} x ${panel.width} mm: ${panel.count} ${this.words.per_panel}`;
        row.append(heading,document.createTextNode(`${Math.round(panel.gap)} mm ${this.words.gap} / ${Math.round(panel.endGap)} mm ${this.words.end}`));
        return row;
      }));
      const link = new URL(this.product.url,location.origin);
      link.searchParams.set('variant',variant.id);
      link.searchParams.set('mt_picket_quantity',result.total);
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) link.searchParams.set('preview_theme_id',preview);
      this.q('[data-review]').href = link.pathname + link.search;
      this.q('[data-review]').removeAttribute('aria-disabled');
    } catch (error) {this.fail(error.message);}
  }
}
if (!customElements.get('mt-picket-planner')) customElements.define('mt-picket-planner',MtPicketPlanner);

  } catch(e) { console.error(e); }
})();
})();
